import { defineMessages } from 'react-intl-next';

export const messages: {
	MissingProfileName: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	MissingProfileTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	OverflowAvatarStackMore: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	OverflowAvatarStackShowMore: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	MissingProfileTooltipGuide: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	DirectReportCountBadgeTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	TotalReportCountBadgeTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	DirectReportBreakdownText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	userSyncInfo: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	userSyncDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	userSyncGuide: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	MissingProfileName: {
		id: 'ptc-atlas.profile-page.manager-and-teams-chart.reporting-lines.missing-profile-name',
		defaultMessage:
			'{numMissingProfiles, plural, one {Missing profile} other {{numMissingProfiles} missing profiles}}',
		description:
			'Text used in place of name for missing profile card showing missing atlassian accounts',
	},
	MissingProfileTooltip: {
		id: 'ptc-atlas.profile-page.manager-and-teams-chart.reporting-lines.missing-profile-name-tooltip',
		defaultMessage:
			'{name} (Looks like {numMissingProfiles, plural, one {that person doesn’t} other {these people don’t}} have an Atlassian account. Ask an admin to add them.)',
		description: 'Text used in tooltips for missing accounts',
	},
	OverflowAvatarStackMore: {
		id: 'ptc-atlas.profile-page.manager-and-teams-chart.reporting-lines.overflow-avatar-stack-more',
		defaultMessage: '{numUsers} more',
		description: 'Text next to avatars when too many users to display by default',
	},
	OverflowAvatarStackShowMore: {
		id: 'ptc-atlas.profile-page.manager-and-teams-chart.reporting-lines.overflow-avatar-stack-show-more',
		defaultMessage: 'Show {numUsers} more',
		description: 'Text next to avatars when too many users to display by default',
	},
	MissingProfileTooltipGuide: {
		id: 'ptc-atlas.profile-page.manager-and-teams-chart.reporting-lines.missing-profile-name-tooltip-guide',
		defaultMessage: 'Read our guide to fixing this',
		description:
			'Link to guide used in tooltips for missing accounts, linked message that points to a guide to fix the issue',
	},
	DirectReportCountBadgeTooltip: {
		id: 'ptc-atlas.profile-page.manager-and-teams-chart.reporting-lines.direct-report-count-badge-tooltip',
		defaultMessage:
			'{directReportCount, plural, one {{directReportCount} direct report} other {{directReportCount} direct reports}}',
		description: 'Text used in tooltip to describe the number of direct reports a manager has',
	},
	TotalReportCountBadgeTooltip: {
		id: 'ptc-atlas.profile-page.manager-and-teams-chart.reporting-lines.total-report-count-badge-tooltip-1',
		defaultMessage:
			'{totalReportCount, plural, one {{totalReportCount} report} other {{totalReportCount} reports}}, {directReportBreakdownText}',
		description:
			'Text used in tooltip to describe the number of direct and total reports a manager has - first part of two',
	},
	DirectReportBreakdownText: {
		id: 'ptc-atlas.profile-page.manager-and-teams-chart.reporting-lines.total-report-count-badge-tooltip-2',
		defaultMessage:
			'{directReportCount, plural, one {{directReportCount} direct} other {{directReportCount} direct}}',
		description:
			'Text used in tooltip to describe the number of direct and total reports a manager has - second part of two',
	},
	userSyncInfo: {
		id: 'atlas.profile.reportring-lines.sync-time-info',
		defaultMessage: 'Last updated {timestamp} ago',
		description: 'Timestamp of the last time user sync has happened in the company',
	},
	userSyncDescription: {
		id: 'atlas.profile.reportring-lines.sync-time-description-1',
		defaultMessage: 'Looks like this information has not been updated since {timestamp}',
		description: 'First part of the user sync description for the reporting lines',
	},
	userSyncGuide: {
		id: 'atlas.profile.reportring-lines.sync-guide',
		defaultMessage: 'Read our guide to fixing this',
		description: 'Link to the user syncing howto article',
	},
});
